<template>
  <div>
    <v-data-table
      :headers="companyUsersHeaders"
      :items="companyUsers"
      class="elevation-1"
      sort-by="createdAt"
      :sort-desc="true"
      :footer-props="{
        'items-per-page-all-text': this.$t('usersDataTable7'),
        'items-per-page-text': this.$t('usersDataTable8'),
        'page-text': this.$t('usersDataTable9')
      }"
    >
      <!-- eslint-disable-next-line -->
      <template v-slot:item.createdAt="{ item }">
        <span>{{ new Date(item.createdAt).toLocaleDateString() }}</span>
      </template>
      <!-- eslint-disable-next-line -->
      <template v-slot:item.role="{ item }">
        <v-btn v-if="isEditUserRoleEnabled && user.data.role === 'admin' && item.userId !== $auth.currentUser.uid" x-small fab @click="showEditUserRole(item)" :elevation="0" class="mr-2">
          <v-icon small>mdi-pen</v-icon>
        </v-btn>
        <span>{{ getRoleAsStr(item.role) }}</span>
      </template>
    </v-data-table>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  props: {
    companyUsers: Array,
    company: Object,
    isEditUserRoleEnabled: Boolean
  },
  data: () => ({
    companyUsersHeaders: [],
  }),
  mounted() {
    this.setCompanyUsersHeaders()
  },
  computed: {
    ...mapGetters({
      user: "user"
    }),
  },
  methods: {
    setCompanyUsersHeaders() {
      this.companyUsersHeaders = [
        { text: this.$t('usersDataTable1'), value: 'email' },
        { text: this.$t('usersDataTable10'), value: 'role', width: '150px'},
        { text: this.$t('usersDataTable2'), value: 'firstName' },
        { text: this.$t('usersDataTable3'), value: 'lastName' },
        { text: this.$t('usersDataTable5'), value: 'dossiersNbCreatedDuringLast30Days' },
        { text: this.$t('usersDataTable6'), value: 'createdAt' },
      ]
      if (this.company.currentMonthlyPeriodDates.startDate) {
        const headerText = `${this.$t('usersDataTable5bis')} (${new Date(this.company.currentMonthlyPeriodDates.startDate * 1000).toLocaleDateString()})`
        this.companyUsersHeaders.splice(this.companyUsersHeaders.length - 1, 0, {
          text: headerText,
          value: 'dossiersNbCreatedDuringCurrentBillingCycle'
        })
      }
    },
    getRoleAsStr(role) {
      return {
        normal: this.$t('role1'),
        manager: this.$t('role2'),
        admin: this.$t('role3'),
        disabled: this.$t('role4')
      }[role]
    },
    showEditUserRole(item) {
      this.$emit('showEditUserRole', item)
    },
  }
}
</script>

<i18n>
{
  "fr": {
    "usersDataTable1": "Email",
    "usersDataTable2": "Prénom",
    "usersDataTable3": "Nom",
    "usersDataTable5": "Dossiers créés sur les 30 derniers jours",
    "usersDataTable5bis": "Dossiers créés depuis le début du cycle mensuel actuel",
    "usersDataTable6": "Date de création de compte",
    "usersDataTable7": "Tous",
    "usersDataTable8": "Nombre d'utilisateurs par page",
    "usersDataTable9": "{0}-{1} sur {2}",
    "usersDataTable10": "Rôle",
    "role1": "Normal",
    "role2": "Manager",
    "role3": "Admin",
    "role4": "Désactivé"
},
  "en": {
    "usersDataTable1": "Email",
    "usersDataTable2": "First name",
    "usersDataTable3": "Last name",
    "usersDataTable5": "Number of CVs created over the last 30 days",
    "usersDataTable5bis": "Number of CVs created since the beginning of current monthly cycle",
    "usersDataTable6": "Date of account creation",
    "usersDataTable7": "All",
    "usersDataTable8": "Number of users per page",
    "usersDataTable9": "{0}-{1} of {2}",
    "usersDataTable10": "Role",
    "role1": "Normal",
    "role2": "Manager",
    "role3": "Admin",
    "role4": "Disabled"
  }
}
</i18n>
